import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Marcas } from '../_model/marcas';
import { Produtos } from '../_model/produtos';
import { MatrixPipe } from '../_pipes/matrix.pipe';
import { MarcasService } from '../_services/marcas.service';
import { ProdutosService } from '../_services/produtos.service';
import { faLayerGroup, faCircle, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-produtos',
    templateUrl: './produtos.component.html',
    styleUrls: ['./produtos.component.less'],
    standalone: false
})
export class ProdutosComponent implements OnInit {

  faLayerGroup = faLayerGroup;
  faCircle = faCircle;
  faPlus = faPlus;
  faMinus = faMinus;

  constructor(private prod: ProdutosService, private route: ActivatedRoute, private marca: MarcasService) {
    this.route.queryParams.subscribe(params => {
      this.query = params['query'];
      this.queryM = (params['queryM'] == "true");
      this.mId = params['marca'];
      this.tInput = params['type'];
      if(!this.tInput)
        this.tInput = "";
      else
        this.links = [{link: '', name: 'Inicio'}];
      if(!this.query) {
        this.query = "";
      }else{
        this.links = [{link: '', name: 'Inicio'}];
      }
      if(this.queryM)
        this.links = [{link: '', name: 'Inicio'}];
      if(this.mId)
        switch (this.tInput) {
          case 'alta': 
            this.links = [{link: '', name: 'Inicio'},{link: 'clock', name: 'Relógios'}];
            break;
          case 'relogio':
            this.links = [{link: '', name: 'Inicio'},{link: 'clock', name: 'Relógios'}];
            break;
          case 'j1':
            this.links = [{link: '', name: 'Inicio'},{link: 'joia', name: 'Joias'}];
          break;
          case 'j2':
            this.links = [{link: '', name: 'Inicio'},{link: 'joia', name: 'Joias'}];
          break;
          case 'acess':
            this.links = [{link: '', name: 'Inicio'},{link: 'acessories', name: 'Acessórios'}];
          break;
          default:
            this.links = [{link: '', name: 'Inicio'}];
          break;
        }
    });
  }

  crums: string = location.search == '' ? '?' : location.search;

  links: any[] = [{link: '', name: 'Inicio'}];

  queryM: boolean = false;

  pm_ctrl: boolean = false;

  list: Produtos[] = [];

  display: Produtos[] = [];

  savedList: Produtos[] = [];

  apiUrl = environment.apiUrl;

  query: string = "";

  type: string[] = [];

  marcas: Marcas[] = [];

  savedMarcas: Marcas[] = [];
  
  fm: Marcas[] = [];

  mId: string = "";

  tInput: string = "";

  splitVal: number = 0;

  matrix: MatrixPipe = new MatrixPipe();

  current: number = 1;

  pags: number = 0;

  ngOnInit() {
    this.prod.list().subscribe((data: Produtos[]) => {
      data.forEach(it => {
        this.list.push(new Produtos(it));
        this.savedList.push(new Produtos(it));
      });
      this.marca.list().subscribe((data: Marcas[]) => {
        data.forEach(it => {
          if(this.queryM) {
            if(it.nome.toLowerCase().includes(this.query.toLowerCase())) {
              this.marcas.push(new Marcas(it));
              this.savedMarcas.push(new Marcas(it));
            }
          }else {
            this.marcas.push(new Marcas(it));
            this.savedMarcas.push(new Marcas(it));
          }
        });
        var temp: Produtos[] = [];
        this.marcas.forEach(el => {
          var t: Produtos[] = this.list.filter(x => x.marcasId == el.id);
          t.forEach(item => {
            temp.push(item);
          });
        });
        this.list = temp;
        this.splitVal = this.marcas.length / 3;
        if(this.mId != "") {
          this.push(this.marcas.filter(x => x.id == Number.parseInt(this.mId))[0]);
        }
        if(this.tInput != "") {
          this.push(this.tInput);
        }
        if(!this.queryM)
          this.list = this.list.filter(x => x.nome.toLowerCase().includes(this.query.toLowerCase()) || x.colecao.toLowerCase().includes(this.query.toLowerCase()));
        this.pags = Math.floor(this.list.length / 8) + (this.list.length % 8 > 0 ? 1 : 0);
      });
    });
  }

  changePM() {
    this.pm_ctrl = !this.pm_ctrl;
  }

  checkEqual(it: string, id: number): boolean {
    return Number.parseInt(it) == id;
  }

  getMarca(item: Produtos) {
    if(item?.marcasId && this.marcas?.length){
      return this.marcas.filter(x => x.id == item.marcasId)[0].nome;
    }
    return "";
  }

  setMarcas(it: Marcas|void) {
    if(it instanceof Object) {
      var temp = this.fm.filter(x => x.id == it.id);
      if(temp.length == 0)
        this.fm.push(it);
      else
        this.fm = this.fm.filter(x => x.id != it.id);
    }
  }

  setType(it: string|void) {
    if(typeof(it) == 'string') {
      var temp = this.type.filter(x => x.includes(it));
      if(temp.length == 0)
        this.type.push(it);
      else
        this.type = this.type.filter(x => !x.includes(it));
      var tml: Marcas[] = [];
      this.type.forEach(el => {
        this.savedMarcas.filter(x => x.tipo.toLowerCase().includes(el.toLowerCase())).forEach(it2 => {
          tml.push(it2);
        });
      });
      this.marcas = tml;
      if(this.type.length == 0)
        this.marcas = this.savedMarcas;
    }
  }

  push(it: string|Marcas) {
    if(it instanceof Object) {
      this.setMarcas(it);
      this.setType();
    }else{
      this.setType(it);
      this.setMarcas();
    }
    var temp: Produtos[] = this.savedList;
    var check = "";
    this.type.forEach(it => {
      check += it+";";
    });
    if(check != "")
      temp = temp.filter(x => this.checkType(check.toLowerCase(),x.tipo.toLowerCase()));
    if(this.fm.length != 0) {
      var temp2: Produtos[] = [];
      this.fm.forEach(i => {
        temp.filter(x => x.marcasId == i.id).forEach(e => {
          temp2.push(new Produtos(e));
        });
      });
      temp = temp2;
    }
    this.list = temp;
    this.pags = Math.floor(this.list.length / 8) + (this.list.length % 8 > 0 ? 1 : 0);
  }

  clearMarcas() {
    this.fm = [];
    var temp: Produtos[] = this.savedList;
    var check = "";
    this.type.forEach(it => {
      check += it+";";
    });
    if(check != "")
      temp = temp.filter(x => this.checkType(check.toLowerCase(),x.tipo.toLowerCase()));
    if(this.fm.length != 0) {
      var temp2: Produtos[] = [];
      this.fm.forEach(i => {
        temp.filter(x => x.marcasId == i.id).forEach(e => {
          temp2.push(new Produtos(e));
        });
      });
      temp = temp2;
    }
    this.list = temp;
    this.pags = Math.floor(this.list.length / 8) + (this.list.length % 8 > 0 ? 1 : 0);
    var mat = this.matrix.transform(this.marcas,this.splitVal);
    for(var i = 0; i < mat.length; i++) {
      for(var j = 0; j < mat[i].length; j++) {
        var input: HTMLInputElement = (<HTMLInputElement> document.getElementById("box-"+i+"-"+j));
        input.checked = false;
      }
    }
  }

  checkType(one: string,two: string): boolean {
    var t1 = one.split(";").filter(x => x != "");
    var t2 = two.split(";").filter(x => x != "");
    var check: boolean = false;
    t1.forEach(it1 => {
      t2.forEach(it2 => {
        if(it1.includes(it2))
          check = true;
      });
    });
    return check;
  }

}
